import type { Room } from '@hollowveil/shared';

export const roomWinterfell: Room = {
  id: 'room_winterfell',
  name: "Westeros - Winterfell en Été",
  description: "Le château ancestral des Stark pendant les beaux jours d'été. Mais l'hiver vient toujours...",
  size: [24, 10, 24],
  floorStyle: 'grass',
  ambiance: {
    realWorld: {
      // Winterfell en été - ciel clair, lumière dorée
      backgroundColor: '#6B8E9F',
      ambientLightColor: '#FFF5DC',
      ambientLightIntensity: 0.85,
    },
    spectralWorld: {
      // Hiver éternel - bleu glacial, Marcheurs Blancs
      backgroundColor: '#0a1a2a',
      ambientLightColor: '#4a8aff',
      ambientLightIntensity: 0.2,
      fogColor: '#1a3a5a',
      fogDensity: 0.08,
    },
  },
  objects: [
    // === MONDE RÉEL - WINTERFELL EN ÉTÉ ===

    // Château principal
    {
      id: 'obj_winterfell_castle',
      name: 'Château de Winterfell',
      type: 'interactive',
      modelId: 'winterfell_castle',
      position: [12, 0, 4],
      rotation: [0, 0, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Winterfell, le siège de la Maison Stark depuis des millénaires. L'hiver vient.",
          },
        },
      ],
    },

    // Tour des Corbeaux
    {
      id: 'obj_raven_tower',
      name: 'Tour des Corbeaux',
      type: 'interactive',
      modelId: 'raven_tower',
      position: [4, 0, 6],
      rotation: [0, 0.2, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La Tour des Corbeaux, d'où partent les messages pour tout le royaume.",
          },
        },
      ],
    },

    // Barral (arbre-cœur)
    {
      id: 'obj_weirwood_tree',
      name: 'Barral',
      type: 'interactive',
      modelId: 'weirwood_tree',
      position: [18, 0, 16],
      rotation: [0, -0.3, 0],
      scale: [2.5, 2.5, 2.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le Barral, l'arbre-cœur du Bois Sacré. Les Anciens Dieux observent à travers ses yeux sculptés.",
          },
        },
      ],
    },

    // Cour d'entraînement
    {
      id: 'obj_training_yard',
      name: 'Cour d\'Entraînement',
      type: 'interactive',
      modelId: 'training_yard',
      position: [8, 0, 12],
      rotation: [0, 0, 0],
      scale: [2, 1, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La cour où les jeunes Stark s'entraînent au combat. 'Plante-les de la pointe, pas du tranchant.'",
          },
        },
      ],
    },

    // Forge
    {
      id: 'obj_forge',
      name: 'Forge',
      type: 'interactive',
      modelId: 'forge',
      position: [4, 0, 14],
      rotation: [0, Math.PI / 4, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La forge de Winterfell. On y fabrique les armes qui protègent le Nord.",
          },
        },
      ],
    },

    // Chenils des loups
    {
      id: 'obj_kennels',
      name: 'Chenils',
      type: 'interactive',
      modelId: 'kennels',
      position: [20, 0, 10],
      rotation: [0, -Math.PI / 6, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Les chenils où vivaient les loups-garous des enfants Stark.",
          },
        },
      ],
    },

    // Murailles
    {
      id: 'obj_wall_section_1',
      name: 'Muraille',
      type: 'static',
      modelId: 'stone_wall',
      position: [0, 0, 12],
      rotation: [0, Math.PI / 2, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_wall_section_2',
      name: 'Muraille',
      type: 'static',
      modelId: 'stone_wall',
      position: [24, 0, 12],
      rotation: [0, -Math.PI / 2, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Puits
    {
      id: 'obj_well',
      name: 'Puits',
      type: 'static',
      modelId: 'well',
      position: [10, 0, 8],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Bannières Stark
    {
      id: 'obj_stark_banner_1',
      name: 'Bannière Stark',
      type: 'static',
      modelId: 'stark_banner',
      position: [10, 0, 5],
      rotation: [0, 0, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_stark_banner_2',
      name: 'Bannière Stark',
      type: 'static',
      modelId: 'stark_banner',
      position: [14, 0, 5],
      rotation: [0, 0, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // === MONDE SPECTRAL - HIVER ÉTERNEL ===

    // Le Mur (au nord - l'opposé du château)
    {
      id: 'obj_the_wall',
      name: 'Le Mur',
      type: 'interactive',
      modelId: 'the_wall',
      position: [12, 0, 2],
      rotation: [0, Math.PI, 0],
      scale: [4, 3, 1],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le Mur... 700 pieds de glace pure. La seule chose qui protège le royaume des horreurs du Nord.",
          },
        },
      ],
    },

    // Trône de Glace du Roi de la Nuit
    {
      id: 'obj_ice_throne',
      name: 'Trône de Glace',
      type: 'interactive',
      modelId: 'ice_throne',
      position: [12, 0, 16],
      rotation: [0, Math.PI, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le trône du Roi de la Nuit. Un froid mortel en émane...",
          },
        },
      ],
    },

    // Spirale des Marcheurs Blancs
    {
      id: 'obj_white_walker_spiral',
      name: 'Spirale de Glace',
      type: 'interactive',
      modelId: 'ice_spiral',
      position: [6, 0, 18],
      rotation: [0, 0, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le symbole des Marcheurs Blancs. Une spirale de corps gelés...",
          },
        },
      ],
    },

    // Congères et glace
    {
      id: 'obj_ice_formation_1',
      name: 'Formation de Glace',
      type: 'static',
      modelId: 'ice_formation',
      position: [4, 0, 20],
      rotation: [0, 0.5, 0],
      scale: [2, 2.5, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_ice_formation_2',
      name: 'Pics de Glace',
      type: 'static',
      modelId: 'ice_spikes',
      position: [20, 0, 18],
      rotation: [0, -0.3, 0],
      scale: [1.8, 2, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_ice_formation_3',
      name: 'Glace',
      type: 'static',
      modelId: 'ice_formation',
      position: [2, 0, 10],
      rotation: [0, 1.2, 0],
      scale: [1.5, 1.8, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Arbres gelés
    {
      id: 'obj_frozen_tree_1',
      name: 'Arbre Gelé',
      type: 'static',
      modelId: 'frozen_tree',
      position: [8, 0, 20],
      rotation: [0, 0.3, 0],
      scale: [1.8, 2, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_frozen_tree_2',
      name: 'Arbre Gelé',
      type: 'static',
      modelId: 'frozen_tree',
      position: [16, 0, 20],
      rotation: [0, -0.5, 0],
      scale: [1.6, 1.8, 1.6],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Dragon de glace mort
    {
      id: 'obj_ice_dragon',
      name: 'Dragon de Glace',
      type: 'interactive',
      modelId: 'ice_dragon',
      position: [20, 0, 14],
      rotation: [0, -Math.PI / 3, 0],
      scale: [2.5, 2.5, 2.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Viserion... autrefois un dragon de feu, maintenant un serviteur de la mort elle-même.",
          },
        },
      ],
    },

    // Cryptes de Winterfell (spectrales)
    {
      id: 'obj_crypts_entrance',
      name: 'Entrée des Cryptes',
      type: 'interactive',
      modelId: 'crypt_entrance',
      position: [12, 0, 8],
      rotation: [0, 0, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "L'entrée des cryptes de Winterfell. Les morts s'agitent dans leurs tombes...",
          },
        },
      ],
    },

    // === OBJETS COLLECTIBLES ===
    {
      id: 'obj_longclaw',
      name: 'Grand-Griffe',
      type: 'interactive',
      modelId: 'valyrian_sword',
      position: [8, 0.5, 11],
      rotation: [0.3, 0.8, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'longclaw',
            itemName: 'Grand-Griffe',
            itemDescription: "L'épée en acier valyrien de Jon Snow. Le pommeau en forme de tête de loup est froid au toucher.",
            itemIcon: 'star',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Vous trouvez Grand-Griffe, l'épée en acier valyrien ! Une des rares armes capables de tuer un Marcheur Blanc.",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_longclaw' },
        },
      ],
    },

    {
      id: 'obj_dragonglass',
      name: 'Verre-Dragon',
      type: 'interactive',
      modelId: 'dragonglass',
      position: [6, 0.2, 16],
      rotation: [0, 0.5, 0.2],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'dragonglass_dagger',
            itemName: 'Dague de Verre-Dragon',
            itemDescription: "Une dague en obsidienne. La seule faiblesse des Marcheurs Blancs.",
            itemIcon: 'scroll',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Du Verre-Dragon ! L'obsidienne volcanique capable de détruire les Marcheurs Blancs.",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_dragonglass' },
        },
      ],
    },
  ],
  puzzles: [],
  connections: [],
  initialWorld: 'real',
  hasSpectralLayer: true,
  palette: 'castle',
  biome: 'ice',
  weather: 'snow',
  weatherIntensity: 0.6,
  npcs: [
    // === MONDE RÉEL - MAISON STARK ===
    {
      id: 'npc_jon_snow',
      type: 'jon_snow',
      name: 'Jon Snow',
      position: [10, 0, 10],
      scale: 3.5,
      idleAnimation: 'stand',
      petAnimation: 'nod',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_arya_stark',
      type: 'arya_stark',
      name: 'Arya Stark',
      position: [6, 0, 10],
      scale: 2.8,
      idleAnimation: 'alert',
      petAnimation: 'smirk',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_sansa_stark',
      type: 'sansa_stark',
      name: 'Sansa Stark',
      position: [14, 0, 8],
      scale: 3.2,
      idleAnimation: 'elegant',
      petAnimation: 'curtsy',
      petRadius: 2.5,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_bran_stark',
      type: 'bran_stark',
      name: 'Bran Stark',
      position: [16, 0, 12],
      scale: 3,
      idleAnimation: 'warg',
      petAnimation: 'vision',
      petRadius: 2,
      petCooldown: 4000,
      isPettable: true,
      visibleInWorld: 'both',
    },
    {
      id: 'npc_ghost',
      type: 'direwolf',
      name: 'Fantôme',
      position: [8, 0, 12],
      scale: 3.5,
      idleAnimation: 'prowl',
      petAnimation: 'nuzzle',
      petRadius: 3,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_tyrion',
      type: 'tyrion_lannister',
      name: 'Tyrion Lannister',
      position: [12, 0, 10],
      scale: 2.5,
      idleAnimation: 'drink',
      petAnimation: 'toast',
      petRadius: 2,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_daenerys',
      type: 'daenerys',
      name: 'Daenerys Targaryen',
      position: [18, 0, 8],
      scale: 3.2,
      idleAnimation: 'regal',
      petAnimation: 'acknowledge',
      petRadius: 3,
      petCooldown: 3500,
      isPettable: true,
      visibleInWorld: 'real',
    },

    // === MONDE SPECTRAL - ARMÉE DES MORTS ===
    {
      id: 'npc_night_king',
      type: 'night_king',
      name: 'Roi de la Nuit',
      position: [12, 0, 14],
      scale: 4.5,
      idleAnimation: 'menace',
      petAnimation: 'raise_dead',
      petRadius: 5,
      petCooldown: 15000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_white_walker_1',
      type: 'white_walker',
      name: 'Marcheur Blanc',
      position: [8, 0, 16],
      scale: 4,
      idleAnimation: 'patrol',
      petAnimation: 'screech',
      petRadius: 4,
      petCooldown: 8000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_white_walker_2',
      type: 'white_walker',
      name: 'Marcheur Blanc',
      position: [16, 0, 16],
      rotation: [0, -Math.PI / 4, 0],
      scale: 4,
      idleAnimation: 'patrol',
      petAnimation: 'screech',
      petRadius: 4,
      petCooldown: 8000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_wight_1',
      type: 'wight',
      name: 'Spectre',
      position: [6, 0, 20],
      scale: 3,
      idleAnimation: 'shamble',
      petAnimation: 'lunge',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_wight_2',
      type: 'wight',
      name: 'Spectre',
      position: [10, 0, 18],
      scale: 2.8,
      idleAnimation: 'shamble',
      petAnimation: 'lunge',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_wight_3',
      type: 'wight',
      name: 'Spectre',
      position: [14, 0, 19],
      scale: 3.2,
      idleAnimation: 'shamble',
      petAnimation: 'lunge',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_wight_4',
      type: 'wight',
      name: 'Spectre',
      position: [18, 0, 20],
      scale: 2.9,
      idleAnimation: 'shamble',
      petAnimation: 'lunge',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_wight_giant',
      type: 'wight_giant',
      name: 'Géant Spectre',
      position: [4, 0, 14],
      scale: 6,
      idleAnimation: 'lumber',
      petAnimation: 'roar',
      petRadius: 5,
      petCooldown: 10000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
  ],
};
